import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from "vue";

import { AdditionalRoleResponse } from "@/types";
import { SnakeToCamelCaseObj } from "@/types/utils/CaseTypes";

interface Props {
  roles: SnakeToCamelCaseObj<AdditionalRoleResponse>[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AdditionalRolesRow',
  props: {
    roles: null
  },
  setup(__props: any) {

const props = __props as {
  roles: SnakeToCamelCaseObj<AdditionalRoleResponse>[];
};


const { roles } = toRefs(props);

return { __sfc: true,props, roles }
}

})